import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ArchivePolicyIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 25",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 .113H7a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h10a5.006 5.006 0 0 0 5-5v-14a5.006 5.006 0 0 0-5-5Zm-10 2h10a3 3 0 0 1 3 3v6H4v-6a3 3 0 0 1 3-3Zm10 20H7a3 3 0 0 1-3-3v-6h16v6a3 3 0 0 1-3 3Zm-6-15h2a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2Zm0 10h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2Z",
    clipRule: "evenodd"
  })
});
export default ArchivePolicyIcon;